export default {
  netFeedIn: {
    UNKNOWN: "Unknown",
    SINGLE_PHASE: "Single phase",
    TWO_PHASE: "Two phase",
    THREE_PHASE: "Three phase",
  },
};
